import PropTypes from "prop-types"
import { useEffect } from "react"
import { useSelector } from "react-redux"

import Media from "components/ui/media"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"
import useKlarnaOSM from "helpers/use-klarna-osm"

const KlarnaContainer = ({ ...props }) => (
  <Media
    className="tablet:items-end tablet:flex-row tablet:max-w-(--tablet-max-width) desktop:max-w-(--desktop-max-width) tablet:min-h-(--tablet-min-height) min-h-(--base-min-height) flex w-fit flex-col items-center"
    style={{
      "--base-min-height": "38px",
      "--desktop-max-width": "280px",
      "--tablet-max-width": "250px",
      "--tablet-min-height": "21px",
    }}
    {...props}
  />
)

const Klarna = ({ price }) => {
  const klarnaOSMLoaded = useKlarnaOSM()

  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  useEffect(() => {
    if (!klarnaOSMLoaded) return

    if (window.Klarna?.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }, [price, klarnaOSMLoaded])

  if (!enableKlarnaCheckout() || price <= 0) {
    return null
  }

  const locale = `en-${sl.config.site_country_for_analytics}`

  return pdpPricingHierarchyExp === 1 ? (
    <>
      {/* <KlarnaContainer lessThan="tablet">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer> */}
      {/* <KlarnaContainer greaterThanOrEqual="tablet"> */}
      <div className="h-20 w-fit overflow-hidden">
        <klarna-placement
          data-key="credit-promotion-auto-size"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </div>
      {/* </KlarnaContainer> */}
    </>
  ) : (
    <>
      <KlarnaContainer lessThan="tablet">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
      <KlarnaContainer greaterThanOrEqual="tablet">
        <klarna-placement
          data-key="credit-promotion-auto-size"
          data-locale={locale}
          data-purchase-amount={price}
        />
      </KlarnaContainer>
    </>
  )
}

Klarna.propTypes = {
  price: PropTypes.number,
}

export default Klarna
